import TextEditor from './TextEditor';
import ReadOnlyTextEditor from './ReadOnlyTextEditor';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useState } from 'react';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`editor-tabpanel-${index}`}
      aria-labelledby={`editor-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const TabToggleEditor = ({
  content = '',
  markdown = '',
  isEditable = true,
  showMenuBar = true,
  placeholder = 'Write something...',
  editorVariant = 'outlined',
  error,
  setContent = () => {},
  setMarkdown = () => {}
}) => {
  const [selectedTab, sertSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    sertSelectedTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }} className='taps-container'>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label='rick text editor'
        style={{ borderBottom: selectedTab === 1 ? '1px solid #cbcbcb' : 'none' }}
      >
        <Tab
          label='Write'
          id={`simple-tab-${0}`}
          aria-controls={`editor-tabpanel-${0}`}
          className={`tap-button ${selectedTab === 0 ? 'tap-button--selected' : ''}`}
        />
        <Tab
          label='Preview'
          id={`simple-tab-${1}`}
          aria-controls={`editor-tabpanel-${1}`}
          className={`tap-button ${selectedTab === 1 ? 'tap-button--selected' : ''}`}
        />
      </Tabs>

      <TabPanel value={selectedTab} index={0}>
        <TextEditor
          content={content}
          markdown={markdown}
          setContent={setContent}
          setMarkdown={setMarkdown}
          isEditable={isEditable}
          showMenuBar={showMenuBar}
          placeholder={placeholder}
          editorVariant={editorVariant}
          error={error}
          typeUploadFolder='dataentry/templates/files'
        />
      </TabPanel>

      <TabPanel value={selectedTab} index={1} style={{ padding: '12px' }}>
        <ReadOnlyTextEditor content={content} />
      </TabPanel>
    </Box>
  );
};

export default TabToggleEditor;
